/* ═══════════════════════════════════════════════════════════════
   OrgChartViewPositionService — read path for per-view member
   placements on a custom org-chart canvas (migration 041, Josh grant
   2026-08-17: "views become separate canvases/boards"). List only:
   every write (place/move/remove a member on a board) rides the edit
   session's ONE `orgchart-commit` transaction (see OrgChartV2.tsx /
   commitOrgChart.ts) — mirrors OrgChartNoteService's read-only shape.
   The generic cache.save()/cache.remove() paths are rejected server-side
   for this table (checkTableAction in ec2-api/server.js) because the
   composite (viewId, memberId) identity has no `id` column for the
   generic dbSave's `ON CONFLICT (id)` to target — so they're not
   exposed here at all, deliberately, same as OrgChartNoteService leaves
   out the dead save()/delete() the older two chart services still carry.
   ═══════════════════════════════════════════════════════════════ */

import * as cache from './cloudCache';
import type { OrgChartViewPosition } from '../../shared/entities';

export const OrgChartViewPositionService = {
  list: async (): Promise<OrgChartViewPosition[]> =>
    cache.list<OrgChartViewPosition>('org_chart_view_positions'),
};
